/*
 * File: ResetPassword.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd October 2024 10:11:57 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Saturday, 26th October 2024 12:34:51 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import OtpField from '../../components/featured/OtpField/OtpField';
import ResetPasswordForm from '../../components/featured/ResetPassword/ResetPasswordForm';
import ResetPasswordConfirm from '../../components/featured/ResetPasswordConfirm/ResetPasswordConfirm';

const ResetPassword = () => {
  const user = sessionStorage.getItem('reset-user') || '';
  //    const otpStored=sessionStorage.getItem('otp')||''
  const stage = sessionStorage.getItem('next') || 'otp';
  const [next, setNext] = useState(stage);
  const [otp, setOtp] = React.useState('');
  const handleNext = () => {
    // sessionStorage.setItem('otp',otp)
    sessionStorage.setItem('next', 'password');
    setNext('password');
  };
  return (
    <>
      {next === 'otp' || !user ? (
        <OtpField user={user} otp={otp} setOtp={setOtp} handleNext={handleNext} />
      ) : next === 'password' ? (
        <ResetPasswordForm otp={otp} user={user} setNext={setNext} />
      ) : (
        <ResetPasswordConfirm />
      )}
    </>
  );
};

export default ResetPassword;
